/**
 *
 * QrScanner
 *
 */

import React, { memo, useState } from 'react';
// import PropTypes from 'prop-types';
import classNames from 'classnames';
// import { Link, useHistory } from 'react-router-dom';

import { FormattedMessage } from 'react-intl';
import messages from './messages';

// styles
import './style.scss';

// import useDeviceDetect from 'utils/useDeviceDetect';

// antd component
//import { Card } from 'antd';
//const { Meta } = Card;

// icons
//import CustomIcons from 'components/CustomIcons';
//import defaultUnitImage from 'images/default.jpg';

// components
import LinkWrapper from 'components/LinkWrapper';

// global user
// import { withUser } from 'engine/Contexts/User.context';
import { BarcodeScanner, SupportedFormat } from '@capacitor-community/barcode-scanner';
import { Button } from 'antd';

function QrScanner({
  // default props
  getResult,
  className,
  ...rest
}) {
  const childClassNames = classNames('QrScanner-wrapper', className);
  //const { isMobile } = useDeviceDetect();

  const [loading, setLoading] = useState(false);

  const startScan = async () => {
    // Check camera permission
    // This is just a simple example, check out the better checks below
    document.body.classList.add("qrscanner");
    // console.debug("Check camera permission");
    await BarcodeScanner.hideBackground();
    // make background of WebView transparent
    // note: if you are using ionic this might not be enough, check below
    const status = await BarcodeScanner.checkPermission({ force: false });
    // console.debug("status", status.granted)
    const result = await BarcodeScanner.startScan({ targetedFormats: [SupportedFormat.QR_CODE] }); // start scanning and wait for a result
    if (result.hasContent) {
        // console.debug("result.content", result.content); // log the raw scanned content
        stopScan();
        document.body.classList.remove("qrscanner");
        getResult(result.content);
      }
  };


  const stopScan = () => {
    BarcodeScanner.showBackground();
    BarcodeScanner.stopScan();
  };

  return (
    <div className={childClassNames}>
      <Button
        type="primary"
        htmlType="submit"
        block
        size="large"
        className="scan-submit"
        loading={loading}
        onClick={() => startScan()}
      >
        Scannez votre code QR
      </Button>
    </div>
  );
}

QrScanner.defaultProps = {};
QrScanner.propTypes = {};

export default memo(QrScanner);
